
import { SignUpForm } from "./SignUpForm";
import { SignInForm } from "./SignInForm";

interface AuthFormProps {
  isSignUp: boolean;
  onToggleMode: () => void;
  onForgotPassword: () => void;
}

export function AuthForm({ isSignUp, onToggleMode, onForgotPassword }: AuthFormProps) {
  return isSignUp ? (
    <SignUpForm />
  ) : (
    <SignInForm onForgotPassword={onForgotPassword} />
  );
}
